<template>
  <div class="task-approver-cell__stack">
    <div
      v-if="showPrimary"
      class="task-approver-cell__avatar-wrap"
    >
      <FcTooltip
        placement="top"
        eager
        transition="fade-transition"
        :open-delay="0"
        :text="primaryTooltip"
      >
        <v-avatar
          size="24"
          class="task-approver-cell__avatar white--text font-small d-flex pa-0 ma-0 noTransform"
          :class="primaryAvatarClass"
          :data-testid="primaryTestId"
        >
          <img
            v-if="isSystemActor"
            src="/img/icons/fbc-icons/SystemActorGlyph.svg"
            alt=""
            class="task-approver-cell__system-glyph"
          />
          <span v-else class="task-approver-cell__avatar-text">{{ primaryUser.initial }}</span>
        </v-avatar>
        <span
          v-if="group.completed"
          class="task-approver-cell__badge"
          aria-hidden="true"
        >
          <img
            src="/img/icons/fbc-icons/ApproverCompleteBadge.svg"
            alt=""
            class="task-approver-cell__badge-image"
          />
        </span>
      </FcTooltip>
    </div>

    <div
      v-if="overflowCount"
      class="task-approver-cell__avatar-wrap"
    >
      <FcTooltip placement="top" eager transition="fade-transition" :open-delay="0">
        <v-avatar
          size="24"
          class="task-approver-cell__overflow d-flex align-center justify-center pa-0 ma-0 noTransform"
          :data-testid="`${testIdPrefix}-more-avatar`"
        >
          +{{ overflowCount }}
        </v-avatar>
        <template #content>
          <div
            v-for="(line, lineIndex) in overflowTooltipLines"
            :key="lineIndex"
          >{{ line }}</div>
        </template>
      </FcTooltip>
    </div>
  </div>
</template>

<script>
import { AUTO_APPROVE } from '../../../../../utils/constants';
import { formatOverflowTooltipLines } from '@/modules/financialclose/components/OverflowList/overflowListUtils';
import FcTooltip from '@/modules/financialclose/components/FcTooltip/FcTooltip.vue';

export default {
  name: 'ApproverAvatarStack',

  components: {
    FcTooltip,
  },

  props: {
    group: {
      type: Object,
      required: true,
    },
    testIdPrefix: {
      type: String,
      default: 'tasklist__approver',
    },
  },

  computed: {
    isSystemActor() {
      return !!this.group.systemActor;
    },
    showPrimary() {
      return this.isSystemActor || !!this.primaryUser;
    },
    primaryUser() {
      return this.group.users[0] || null;
    },
    overflowUsers() {
      if (this.isSystemActor) return this.group.users || [];
      return (this.group.users || []).slice(1);
    },
    overflowCount() {
      return this.overflowUsers.length;
    },
    primaryAvatarClass() {
      return this.group.completed || this.isSystemActor
        ? 'task-approver-cell__avatar--completed'
        : 'task-approver-cell__avatar--pending';
    },
    primaryTestId() {
      return this.isSystemActor
        ? `${this.testIdPrefix}-system-actor`
        : `${this.testIdPrefix}-avatar`;
    },
    primaryTooltip() {
      if (this.isSystemActor) return AUTO_APPROVE.DETAIL_BADGE;
      if (this.group.completed && this.group.completedTooltip) {
        return this.group.completedTooltip;
      }
      return this.primaryUser?.name || '';
    },
    overflowTooltipLines() {
      const names = this.overflowUsers.map((user) => user.name);
      return formatOverflowTooltipLines(names);
    },
  },
};
</script>

<style>
.task-approver-cell__avatar-text {
  font-size: var(--font-size-xxs, 12px) !important;
  font-weight: var(--font-weight-semibold, 600);
  text-transform: capitalize;
  pointer-events: none;
}
</style>
